/**@internal
 *
 */
export var Method;
(function (Method) {
    Method[Method["Init"] = 1] = "Init";
    Method[Method["Continue"] = 2] = "Continue";
    Method[Method["Term"] = 3] = "Term";
    Method[Method["Authenticate"] = 4] = "Authenticate";
})(Method || (Method = {}));
/**@internal
 *
 */
export var MessageType;
(function (MessageType) {
    MessageType[MessageType["Response"] = 0] = "Response";
    MessageType[MessageType["Notification"] = 1] = "Notification";
})(MessageType || (MessageType = {}));
//# sourceMappingURL=messages.js.map